(ns app.dashboard.math
  (:require [day8.re-frame.http-fx]
            [goog.string :as gstring]
            [re-posh.core :as re-posh]
            [clojure.pprint :as clojure-print]
            [app.subs :as subs]))


(defn percentage-calc [value]
  (* 100 value))

(defn number-validation [value]
  (if (and (some? value) (number? value) (not (zero? value)) (not (= (str value) "NaN")) (not (infinite? value)))
    true
    false))

(defn subs-calc [x y]
  (if (pos? (- x y))
    (- x y)
    (Math/abs (- x y))))


(defn clean-num [number]
  (if (number-validation number) 
    (gstring/format "%.1f" number)
    "N/A"))




(defn order-num [number] 
  (if (number-validation number)
    (clojure-print/cl-format  nil "~:d" number)
    "N/A")
  )



(defn open-rate-calc [current-open current-sent previous-open previous-sent]
  (let [val (- (/ current-open current-sent) (/ previous-open previous-sent))]
    (if (number-validation val)
      (str (clean-num (percentage-calc (if (neg? val)
                                         (Math/abs val)
                                         val))) "pp")
      "N/A")))


(defn response-rate-calc [current-responses current-sent previous-responses previous-sent]
  (let [val (- (/ current-responses current-sent) (/ previous-responses previous-sent))] 
    (if (number-validation val)
      (str (clean-num (percentage-calc (if (neg? val)
                                         (Math/abs val)
                                         val))) "pp")
      "N/A")
    ))


(defn subs-movement-calc [current-val current-sent previous-val previous-sent]
  (let [val (- (/ current-val current-sent) (/ previous-val previous-sent))]
    (if (neg? val)
      (clean-num val)
      (Math/abs val))))


(defn retrive-activity-data [dashboard? data]
  (if dashboard?
    (into {} (map  (fn [value] {(keyword (:activity value)) (:count_occ value)}) data))
    (into {} (map  (fn [value] {(keyword (:activity value)) (:count_occ value)}) (:statistics/statistics-folder-data @(re-posh/subscribe [::subs/recent-updated-products]))))))


(defn display-percentage [current-open current-sent] 
  (if (number-validation (percentage-calc (/ current-open current-sent)))
    (str (clean-num (percentage-calc (/ current-open current-sent))) "%")
    "N/A"))


